import {Injectable, OnDestroy} from '@angular/core';
import {Tenant, User}          from '@src/app/admin/users/models/user.model';
import {environment}           from '@src/environments/environment';
import * as LaunchDarkly       from 'launchdarkly-js-client-sdk';
import {LDFlagValue}           from 'launchdarkly-js-client-sdk';
import {Observable, Subject}   from 'rxjs';
import {map}                   from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService implements OnDestroy
{
    public client: LaunchDarkly.LDClient;

    constructor()
    {
    }

    public async initialize(user: User, tenant: Tenant): Promise<void>
    {
        const context = {
            kind: 'multi',
            user: {
                key: `${user.id}`,
                name: user.name,
                email: user.email,
                type: user.type.title,
                anonymous: false,
            },
            tenant: {
                key: `${tenant.id}`,
                name: tenant.name,
                status: tenant.status,
            }
        } as LaunchDarkly.LDMultiKindContext;

        this.client = LaunchDarkly.initialize(environment.launchDarkly.clientId, context, {
            // bootstrap: 'localStorage',
        });
    }

    public getFlag(flagKey: string, defaultValue: LDFlagValue = false): Observable<LDFlagValue>
    {
        const TIMEOUT_SECONDS = 1;
        const fetchFlag = new Subject<void>();

        if (!this.client) {
            console.error('LaunchDarkly client is not initialized. Call initialize() first.');
            // Return an observable with the default value
            return new Observable(observer => {
                observer.next(defaultValue);
                observer.complete();
            });
        }

        this.client.on(`change:${flagKey}`, () => {
            fetchFlag.next();
        });

        this.client.waitUntilReady().then(() => {
            fetchFlag.next();
        });

        return fetchFlag.pipe(
            map(() => {
                return this.client.variation(flagKey, defaultValue);
            })
        );
    }

    public async ngOnDestroy(): Promise<void>
    {
        await this.client.close();
    }
}
